import React from 'react';
import { LocalString, Plural, Money } from 'translate-react';
import PeopleSelect from '../components/PeopleSelect';

import { connect } from 'react-redux';

import {
	changePeople,
	addRoom,
	togglePanel
} from '../actions';

let PeopleIcons = require('./PeopleIcons.js').default;


let ObjectColumns = (props, context) => {
	let { open, desktop, people } = props;
	let { changePeople, addRoom, togglePanel } = props;
	let room = props.ident.substr(4);
	let rooms = desktop.rooms;

	let adults = people["rooms." + room + ".adults"];
	let children = people["rooms." + room + ".children"];
	let roomstate = desktop["room" + room];

	let showNext = (props.ident == "room1" && rooms == 1) || (props.ident == "room2" && rooms == 2);

	/* Wenn der Block zu ist, die volle Zusammenfassung anzeigen */
	if ( !open ) {
		return (
			<div style={{height:'100%'}}>
				<div className="accordion-col accordion-col1">
					<b>Objekt</b>
					<span>Wohnung 4</span>
					<br/>
					{ showNext ? <button onClick={(e) => addRoom()}><LocalString word="Weiteres Objekt" /></button> : null}
				</div>
				<div className="accordion-col accordion-col2">
					<b>Belegung</b>
					<span>{adults} Erwachsene, {children} Kinder</span>
					<PeopleIcons adults={adults} children={children} />
				</div>
				<div className="accordion-col accordion-col3">
					<b><LocalString word="Preis" /></b>
					<span className="price"><Money map={{EUR: 355.60, CHF: 400, USD: 320}} /></span>
					<small>Gesamtpreis inkl. Verpflegung, ohne Verpflegung zzgl. Kurbeitrag</small>
				</div>
				<div className="accordion-col accordion-col4">
					{!open ? 
					<button onClick={(e) => togglePanel(props.ident)}>
						<LocalString word="Ändern" />
					</button>
					: null}
				</div>
			</div>
		);
	}

	/* Wenn wir "offen" sind, zeigen wir den kompletten PeopleSelect an */
	if ( roomstate.people_open ) {

		return (
			<div style={{height:'100%'}}>
				<div className="accordion-col accordion-col12">
					<PeopleSelect state={people} onChange={changePeople} room={1} />
				</div>
				<div className="accordion-col accordion-col3">
					
				</div>
				<div className="accordion-col accordion-col4">
					
				</div>
			</div>
		);

	}

	/* Wenn wir "zu" sind, zeigen wir nur eine kleine Übersicht an an */
	if ( !roomstate.people_open ) {

		return (
			<div style={{height:'100%'}}>
				<div className="accordion-col accordion-col1">
					<b>Objekt</b>
					<span>Wohnung 4</span>
					<br/>
					{ showNext ? <button onClick={(e) => context.store.dispatch(addRoom())}><LocalString word="Weiteres Objekt" /></button> : null}
				</div>
				<div className="accordion-col accordion-col2">
					<b>Belegung</b>
					<span>2 Erwachsene</span>
					<PeopleIcons adults={adults} children={children} />
				</div>
				<div className="accordion-col accordion-col3">
					<b><LocalString word="Preis" /></b>
					<span className="price"><Money map={{EUR: 355.60, CHF: 400, USD: 320}} /></span>
					<small>Gesamtpreis inkl. Verpflegung, ohne Verpflegung zzgl. Kurbeitrag</small>
				</div>
				<div className="accordion-col accordion-col4">
					{!open ? 
					<button onClick={(e) => context.store.dispatch(togglePanel(props.ident))}>
						<LocalString word="Ändern" />
					</button>
					: null}
				</div>
			</div>
		);

	}

};



const mapStateToProps = (state) => ({
    desktop: state.desktop,
    people: state.people,
})

const mapDispatchToProps = (dispatch) => ({
	changePeople: people => dispatch(changePeople(people)),
	addRoom: _ => dispatch(addRoom()),
	togglePanel : panel => dispatch(togglePanel(panel)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ObjectColumns);






/** WEBPACK FOOTER **
 ** ../ibe/desktop/ObjectColumns.js
 **/